import { useCurrentTracking } from './use-current-tracking';
export function useTrackingActions() {
  var _useCurrentTracking$a, _useCurrentTracking;

  return (_useCurrentTracking$a = (_useCurrentTracking = useCurrentTracking()) === null || _useCurrentTracking === void 0 ? void 0 : _useCurrentTracking.actions) !== null && _useCurrentTracking$a !== void 0 ? _useCurrentTracking$a : [];
}